module.exports = "<div class=\"hx-control-message-component\"\n     *ngIf=\"getErrorMessage() !== null\">\n    {{ getErrorMessage() }}\n</div>\n"